import { StatusBar } from '#components/StatusBar'
import { pluralize } from '#util'

export function PageCount({ count }: { count: number }) {
  'use memo'

  return (
    <StatusBar.Text>{String(count) + pluralize(count, ' page')}</StatusBar.Text>
  )
}
